import { themed } from '@indeed/ifl-css';

// Cannot use logical properties entirely due to how Popper handles flipping between LTR/RTL
const PopoverArrow = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["backgroundColor", "borderColor"],
  shouldForwardProp: prop => prop !== "backgroundColor" && prop !== "borderColor",
  target: "e1qfk92r0"
} : {
  styleProps: ["backgroundColor", "borderColor"],
  shouldForwardProp: prop => prop !== "backgroundColor" && prop !== "borderColor",
  target: "e1qfk92r0",
  label: "PopoverArrow"
})(_ref => {
  let {
    backgroundColor,
    borderColor
  } = _ref;
  return [{
    inlineSize: "16px",
    blockSize: "16px",
    "&::after": {
      content: '""',
      position: "absolute",
      zIndex: -1,
      borderColor,
      borderStyle: "solid",
      filter: "brightness(0.9)"
    },
    "&::before": {
      content: '""',
      position: "absolute",
      borderColor: backgroundColor,
      borderStyle: "solid"
    },
    [`[data-placement^="top"] > &`]: {
      bottom: 0,
      "&::before": {
        borderBottomColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        blockSize: "8px",
        top: "14px",
        left: "0 /* @noflip */",
        borderWidth: "8px 8px 0 /* @noflip */",
        transformOrigin: "center top"
      },
      "&::after": {
        borderBottomColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        borderWidth: "7px 7px 0 /* @noflip */",
        blockSize: "7px",
        top: "16px",
        left: "1px /* @noflip */"
      }
    },
    [`[data-placement^="bottom"] > &`]: {
      top: 0,
      "&::before": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        blockSize: "8px",
        bottom: "14px",
        left: "0 /* @noflip */",
        borderWidth: "0 8px 8px /* @noflip */"
      },
      "&::after": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        borderWidth: "0 7px 7px /* @noflip */",
        blockSize: "7px",
        bottom: "16px",
        left: "1px /* @noflip */"
      }
    }
  }, {
    [`[data-placement^= "left"] > & `]: {
      right: "0 /* @noflip */",
      "&::before": {
        borderTopColor: "transparent",
        borderRightColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        right: "-6px /* @noflip */",
        borderWidth: "8px 0 8px 8px /* @noflip */",
        transformOrigin: "center left /* @noflip */"
      },
      "&::after": {
        borderTopColor: "transparent",
        borderRightColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        borderWidth: "7px 0 7px 7px /* @noflip */",
        left: "16px /* @noflip */",
        top: "1px"
      }
    },
    [`[data-placement^="right"] > & `]: {
      left: "0 /* @noflip */",
      "&::before": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        left: "-6px /* @noflip */",
        borderWidth: "8px 8px 8px 0 /* @noflip */",
        transformOrigin: "center left /* @noflip */"
      },
      "&::after": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        borderWidth: "7px 7px 7px 0 /* @noflip */",
        right: "16px /* @noflip */",
        top: "1px"
      }
    }
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export { PopoverArrow };
